import { makeAutoObservable, runInAction } from 'mobx'
import { setLocalStorageItem } from 'shared/hooks/useLocalStorage'
import type { IEntitiesStore } from 'entities/EntitiesExport'

type IMenuStoreConfig = {
  key: string
}

export class MenuStore {
  private _loading = true

  constructor(private _config: IMenuStoreConfig, private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get loading() {
    return this._loading
  }

  init = async () => {
    runInAction(() => {
      this._loading = true
    })

    await Promise.all([
      this._entities.usersStore.initPromise,
      this._entities.userPermissionsStore.initPromise,
      this._entities.featureFlagsStore.fetchFeatureFlags(),
      this._entities.subscriptionStore.initPromise,
      this._entities.organizationStore.initPromise,
      this._entities.inboxesStore.initPromise,
    ])

    runInAction(() => {
      this._loading = false
    })
  }

  setCachePath = (path: string) => {
    const usersId = this._entities.usersStore.user_owner_id
    const key = this._config.key

    setLocalStorageItem(`${usersId}_menu_${key}`, path)
  }
}
